import { useMemo } from "../../__compat__/react/main.entry.mjs.mjs";
import { mergeSizes } from "../../utils/spacing/mergeSizes.mjs.mjs";
/**
 * Custom hook to extract SpacingProps from a given set of props and transforms
 * them to an CSS shorthand notation array with four entries
 *
 * @param {Object} props List of props
 * @returns {SpacingShorthandList}
 */
export function useSpacing({ spacing: shorthand, spaceStackStart: stackStart, spaceInlineEnd: inlineEnd, spaceStackEnd: stackEnd, spaceInlineStart: inlineStart, }) {
    return useMemo(() => mergeSizes(shorthand, [stackStart, inlineEnd, stackEnd, inlineStart]), [shorthand, stackStart, inlineEnd, stackEnd, inlineStart]);
}
export function useInsetSpacing({ spacingInset: shorthand, spaceInsetStackStart: stackStart, spaceInsetInlineEnd: inlineEnd, spaceInsetStackEnd: stackEnd, spaceInsetInlineStart: inlineStart, }) {
    return useMemo(() => mergeSizes(shorthand, [stackStart, inlineEnd, stackEnd, inlineStart]), [shorthand, stackStart, inlineEnd, stackEnd, inlineStart]);
}
//# sourceMappingURL=useSpacing.mjs.mjs.map